import Debug from 'debug';
// import { join } from 'path';
// import { cwd } from 'process';
import { TemplateFunction } from './build-code/buildTemplate';

export type RequestNavigationType = {
  patterns?: [RegExp|string];
  base?: string;
}

export type Config = {
  attribute?: string;
  createTemplate?: TemplateFunction;
  // argument passed to --config
  config?: string;
  rootDir: string;
  testTimeout: number;
  useTypeScript: boolean;
  actions?: {
    hook?: any,
    request?: RequestNavigationType,
    navigation?: RequestNavigationType,
    log?: {
      realtime?: boolean
    },
    click?: {
      attributes?: string
    },
    console?: any
  }; 
};

const debug = Debug('qali:config');

export const getConfigPath = (): string => require('path').join(require('process').cwd(), 'qali.config.js');

export const loadConfig = (path?: string): Config => {
  let userConfig: any;
  if (typeof window !== 'undefined') {
    const windowConfig = window && window['config']
    if(windowConfig){
      return windowConfig
    }
  }
  try {
    const configPath = path || getConfigPath();
    debug('load config from %s', configPath);

    userConfig = require(configPath);
  } catch (error) {
    console.error(error)
    debug(`error loading config from ${error.message}`);

    // use defaults
    return {
      config: 'node_modules/qali/js-jest.config.json',
      rootDir: '.qali',
      testTimeout: 60000,
      useTypeScript: false,
      actions: {}
    };
  }

  const config: Config = {
    attribute: userConfig.attribute,
    createTemplate: userConfig.createTemplate,
    // do not override config when this is found in user config
    config: userConfig.config,
    rootDir: userConfig.rootDir || '.qali',
    testTimeout: userConfig.testTimeout || 60000,
    useTypeScript: userConfig.useTypeScript || false,
    actions: userConfig.actions || {}
  };

  return config;
};
